import React from 'react';
import PropTypes from 'prop-types';
import Img from '../Img';
import styles from './styles.sass';

const PressRatings = ({ isAmp }) => (
  <div className={styles.appRatings}>
    <div className={styles.ratingsDiv}>
      <h3>"App of the Day"</h3>
      <p>
        <Img
          isAmp={isAmp}
          alt="Podcast App store logo"
          src="https://d12xoj7p9moygp.cloudfront.net/images/press/appstore-logo.png"
          width={20}
          height={20}
        />
        &nbsp;Apple's App Store
      </p>
    </div>
    <div className={styles.ratingsDiv}>
      <span className={styles.appStoreRating}>⭐️ ⭐️ ⭐️ ⭐️ ⭐️</span>
      <p>
        <Img
          isAmp={isAmp}
          alt="Podcast App store logo"
          src="https://d12xoj7p9moygp.cloudfront.net/images/press/appstore-logo.png"
          width={20}
          height={20}
        />
        &nbsp;Average rating on the App Store
      </p>
    </div>
    <div className={styles.ratingsDiv}>
      <h3>"Best Apps of 2018" 🏆</h3>
      <Img
        isAmp={isAmp}
        alt="Podcast Google Play logo"
        src="https://d12xoj7p9moygp.cloudfront.net/images/press/googleplay-logo.png"
        withRetina
        width={110}
        height={22}
        style={{
          'min-height': `22px`,
        }}
      />
    </div>
  </div>
);

PressRatings.propTypes = {
  isAmp: PropTypes.bool,
};

PressRatings.defaultProps = {
  isAmp: false,
};

export default PressRatings;
